export var Products;
(function (Products) {
    Products["myTenNights"] = "mytennights";
    Products["myTenDays"] = "mytendays";
    Products["fridayGiving"] = "fridaygiving";
})(Products || (Products = {}));
export var ProductName;
(function (ProductName) {
    ProductName["myTenNights"] = "MyTenNights";
    ProductName["myTenDays"] = "MyTenDays";
    ProductName["fridayGiving"] = "FridayGiving";
    ProductName["everGive"] = "EverGive";
})(ProductName || (ProductName = {}));
export var ProductType;
(function (ProductType) {
    ProductType["fridayGiving"] = "fridayGiving";
    ProductType["everGive"] = "everGive";
})(ProductType || (ProductType = {}));
export var RecordType;
(function (RecordType) {
    RecordType["FGS"] = "FGS";
    RecordType["WFS"] = "WFS";
})(RecordType || (RecordType = {}));
export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["FridayGiving"] = "Friday Giving";
    ScheduleType["EverGive"] = "EverGive";
})(ScheduleType || (ScheduleType = {}));
export const isMultiCharity = (charityId) => charityId.startsWith('multi-charity');
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvZHVjdHMuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsiY29tbW9uL1Byb2R1Y3RzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLFFBSVg7QUFKRCxXQUFZLFFBQVE7SUFDbEIsdUNBQTJCLENBQUE7SUFDM0IsbUNBQXVCLENBQUE7SUFDdkIseUNBQTZCLENBQUE7QUFDL0IsQ0FBQyxFQUpXLFFBQVEsS0FBUixRQUFRLFFBSW5CO0FBRUQsTUFBTSxDQUFOLElBQVksV0FLWDtBQUxELFdBQVksV0FBVztJQUNyQiwwQ0FBMkIsQ0FBQTtJQUMzQixzQ0FBdUIsQ0FBQTtJQUN2Qiw0Q0FBNkIsQ0FBQTtJQUM3QixvQ0FBcUIsQ0FBQTtBQUN2QixDQUFDLEVBTFcsV0FBVyxLQUFYLFdBQVcsUUFLdEI7QUFFRCxNQUFNLENBQU4sSUFBWSxXQUdYO0FBSEQsV0FBWSxXQUFXO0lBQ3JCLDRDQUE2QixDQUFBO0lBQzdCLG9DQUFxQixDQUFBO0FBQ3ZCLENBQUMsRUFIVyxXQUFXLEtBQVgsV0FBVyxRQUd0QjtBQUVELE1BQU0sQ0FBTixJQUFZLFVBR1g7QUFIRCxXQUFZLFVBQVU7SUFDcEIseUJBQVcsQ0FBQTtJQUNYLHlCQUFXLENBQUE7QUFDYixDQUFDLEVBSFcsVUFBVSxLQUFWLFVBQVUsUUFHckI7QUFFRCxNQUFNLENBQU4sSUFBWSxZQUdYO0FBSEQsV0FBWSxZQUFZO0lBQ3RCLDhDQUE4QixDQUFBO0lBQzlCLHFDQUFxQixDQUFBO0FBQ3ZCLENBQUMsRUFIVyxZQUFZLEtBQVosWUFBWSxRQUd2QjtBQUNELE1BQU0sQ0FBQyxNQUFNLGNBQWMsR0FBRyxDQUFDLFNBQWlCLEVBQVcsRUFBRSxDQUFDLFNBQVMsQ0FBQyxVQUFVLENBQUMsZUFBZSxDQUFDLENBQUEifQ==